module.exports = __webpack_public_path__ + "static/media/dispenseTheCards_3.782b2e20.mp3";